import { REQUIRED_MESSAGES } from '@srm/ui/lib/requiredMessage';
import React, { useEffect, useState } from 'react';
import { UseFormReturn } from 'react-hook-form';
import InputControl from '@srm/ui/controls/InputControl';
import SelectControl from '@srm/ui/controls/SelectControl';
import AbookpickerControl from '@controls/AbookpickerControl';
import { IOption } from '@srm/ui/types/IOption';
import { accessTypeItems } from './documentTemplateAccess';
import { IAddressBookData } from '@models/addressbook/IAddressBookData';
import { IAbookTab } from '@models/Forms/IForms';
import { requiredTextRules } from '@srm/ui/lib/requiredTextRules';

const tabSettings = {
    name: 'Подразделение',
    mode: 'list',
    child: 'Department',
    columns: [{ key: 'fullName', name: 'Наименование', width: '', allowSort: true }],
    cache: JSON.stringify({
        name: 'Подразделение',
        mode: 'list',
        child: 'Department',
    }),
} as IAbookTab;

interface IDocumentTemplateFieldsProps {
    formState: UseFormReturn<any>;
    /** Подставить «Только мне» в сам контрол — так делает создание шаблона */
    withDefaultAccess?: boolean;
    /** Доступ, пришедший с сервера: раскрывает выбор подразделений при открытии */
    initialAccess?: string;
}

/** Поля шаблона документа: название, кому доступен и (для «Подразделению») сами подразделения. */
export const DocumentTemplateFields: React.FC<IDocumentTemplateFieldsProps> = ({
    formState,
    withDefaultAccess,
    initialAccess,
}: IDocumentTemplateFieldsProps) => {
    const [showSelectDepartments, setShowSelectDepartments] = useState<boolean>(false);
    const [depsDisplayValue, setDepsDisplayValue] = useState<string>('');
    const [formValues] = useState<string>('{}');

    useEffect(() => {
        if (initialAccess === undefined) return;

        const isDepartment = initialAccess !== '' && initialAccess !== '-1' && initialAccess !== null;
        setShowSelectDepartments(isDepartment);
        setDepsDisplayValue(isDepartment ? initialAccess.replaceAll('|', ', ') : '');
    }, [initialAccess]);

    return (
        <>
            <InputControl
                label="Название шаблона"
                readOnly={false}
                required={true}
                rules={requiredTextRules()}
                name="templateName"
                control={formState.control}
            />
            <SelectControl
                label="Шаблон доступен"
                multiselect={false}
                onlySelect={true}
                readOnly={true}
                required={true}
                rules={{ required: REQUIRED_MESSAGES.select }}
                name="templateAccess"
                options={accessTypeItems}
                control={formState.control}
                defaultValue={withDefaultAccess ? [accessTypeItems[0]] : undefined}
                onValueChange={(option: IOption[]) => {
                    const isDep = option[0]?.value === 'dep';
                    setShowSelectDepartments(isDep);
                    if (!isDep) {
                        setDepsDisplayValue('');
                        formState.setValue('deps', '');
                    }
                }}
            />
            {showSelectDepartments && (
                <AbookpickerControl
                    formGroupProps={{ className: 'form-group-margin-top' }}
                    label="Подразделение"
                    displayValue={depsDisplayValue}
                    formValues={formValues}
                    name="deps"
                    showChips={false}
                    tabsSettings={[tabSettings]}
                    isMultiple={true}
                    title="Адресная книга"
                    required={true}
                    rules={{ required: REQUIRED_MESSAGES.multiple }}
                    control={formState.control}
                    onSetValues={(value: IAddressBookData[]) => {
                        setDepsDisplayValue(
                            value && value.length > 0
                                ? value.map((item) => item.fullName ?? item.name).join(', ')
                                : '',
                        );
                    }}
                />
            )}
        </>
    );
};
